<template>
	<v-app theme="dark" style="background-color: #eeeeee">
		<v-main>
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12 primary white--text">
							<v-toolbar-title>
								<v-img
									class="mx-auto mt-5"
									alt="Orixe Logo"
									:src="require('../../assets/Logo_Header_White.svg')"
									width="40%"
								/>
								<h1 class="mt-2 ml-5 white--text text-left">Choose Your New Password</h1>
							</v-toolbar-title>
							<v-form @submit.prevent="changePassword">
								<v-alert type="error" class="ma-4" v-if="tokenInvalid">The token you provided was invalid. Please submit a new request for a password reset. <v-btn light to="/forgot">Reset Password</v-btn></v-alert>
								<v-card-text>
									<div v-if="showNewPasswordInput">
										<secure-password-field
											:append-icon="showNew ? 'fas fa-eye' : 'fas fa-eye-slash'"
											:visible="showNew"
											v-model="password"
											label="New Password"
											class="input-group--focused"
											dark
											:rejection-errors="passwordRejectionErrors"
											@click:append="showNew = !showNew"
										/>
										<secure-password-field
											:append-icon="showConfirm ? 'fas fa-eye' : 'fas fa-eye-slash'"
											:visible="showConfirm"
											v-model="confirmpassword"
											label="Confirm New Password"
											class="input-group--focused"
											dark
											:show-guidance="false"
											:enforce-policy="false"
											:rules="[rules.confirmMatch]"
											@click:append="showConfirm = !showConfirm"
										/>
									</div>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn v-if="showNewPasswordInput" type="submit" color="secondary" class="ma-3">Login</v-btn>
								</v-card-actions>
							</v-form>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<test-error />
	</v-app>
</template>

<script>
import store from "../../store"
import router from "../../router"
import LoadingState from "../../consts/LoadingState"
import SecurePasswordField from "../../components/SecurePasswordField.vue"
import { extractApiErrorDetails } from "../../utils/recaptcha"
export default {
	name: "Login",
	components: { SecurePasswordField },
	data() {
		return {
			password: null,
			confirmpassword: null,
			token: null,
			showNewPasswordInput: false,
			tokenInvalid: false,
			passwordRejectionErrors: [],
			rules: {
				required: (value) => !!value || "Required.",
				confirmMatch: () => true,
			},
			showNew: false,
			showConfirm: false,
		}
	},
	created() {
		this.rules.confirmMatch = (v) => v === this.password || "Passwords do not match."
	},
	methods: {
		changePassword() {
			this.passwordRejectionErrors = []
			store
				.dispatch("user/resetPassword", {
					token: this.token,
					password: this.password,
				})
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Password was successfully reset!",
						{ root: true }
					)
					router.push("/")
				})
				.catch((error) => {
					const details = extractApiErrorDetails(error)
					if (details.length) {
						this.passwordRejectionErrors = details
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
	},
	mounted() {
		this.token = this.$route.query.token || "0"
		store
			.dispatch("user/verifyResetPasswordToken", {
				token: this.token,
			})
			.then(() => {
				this.showNewPasswordInput = true
				this.tokenInvalid = false
			})
			.catch(() => {
				this.tokenInvalid = true
			})
	},
}
</script>